/**
 * Domain Vocabulary — Client-side STT auto-corrections
 *
 * Mirrors the backend domainVocabulary.js for client-side use with
 * the Web Speech API. Corrections are applied immediately after
 * recognition results arrive, before sending to the AI.
 *
 * @module utils/domainVocabulary
 */

// ── Word-Level Corrections ───────────────────────────────────────────────────

const WORD_CORRECTIONS = {
  tast: 'task', tusk: 'task', tax: 'task', taks: 'task', taask: 'task',
  tusks: 'tasks', tasts: 'tasks', taxs: 'tasks',
  'sub task': 'subtask', 'sub tasks': 'subtasks',
  progect: 'project', projeckt: 'project', projet: 'project',
  'mile stone': 'milestone', 'my stone': 'milestone',
  'my stones': 'milestones', 'mile stones': 'milestones',
  prority: 'priority', prioirty: 'priority', priortiy: 'priority',
  'in progress': 'in-progress', 'in progess': 'in-progress',
  'to do': 'todo', 'to due': 'todo',
  'dew date': 'due date', 'do date': 'due date', 'doo date': 'due date',
  'dead line': 'deadline', 'dead lion': 'deadline',
  'a sign': 'assign', 'a sine': 'assign', 'a signed': 'assigned', 'un assign': 'unassign',
  'can ban': 'kanban', comban: 'kanban', 'com bon': 'kanban',
  'gant chart': 'gantt chart', 'gone chart': 'gantt chart', gant: 'gantt',
  calander: 'calendar', calender: 'calendar', calandar: 'calendar',
  dashbord: 'dashboard', 'dash board': 'dashboard',
  'cam pain': 'campaign', 'cam pane': 'campaign', campain: 'campaign',
  finanse: 'finance', expence: 'expense', expences: 'expenses',
  budjet: 'budget', buget: 'budget',
  invoce: 'invoice', receit: 'receipt', reciept: 'receipt',
  teem: 'team', teems: 'teams',
  'tusk leena': 'lina', 'task leena': 'lina', 'tusk lena': 'lina', taskelina: 'lina', leena: 'lina', leana: 'lina',
};

// ── Boost Terms (for SpeechRecognitionPhrase where supported) ────────────────

export const BOOST_TERMS = [
  'task', 'tasks', 'project', 'milestone', 'kanban', 'assignee',
  'Lina', 'todo', 'subtask', 'deadline', 'priority', 'dashboard',
  'gantt', 'sprint', 'backlog', 'in-progress', 'overdue', 'calendar',
  'finance', 'budget', 'invoice', 'expense', 'receipt', 'assign',
  'unassign', 'create', 'delete', 'update', 'due date', 'team', 'campaign',
];

/**
 * Apply domain-specific corrections to an STT transcript.
 *
 * @param {string} rawText — raw transcript from Web Speech API
 * @returns {string} — corrected text
 */
export function correctTranscript(rawText) {
  if (!rawText || typeof rawText !== 'string') return rawText;
  let text = rawText;

  for (const [wrong, right] of Object.entries(WORD_CORRECTIONS)) {
    const escaped = wrong.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(`\\b${escaped}\\b`, 'gi');
    text = text.replace(re, right);
  }

  return text.replace(/\s{2,}/g, ' ').trim();
}

export default WORD_CORRECTIONS;
